export default {
      id: "volume-mobile-usage",
      viewBox: "0 0 23 39",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#volume-mobile",
      toString: function () {
        return this.url;
      }
    }